<script setup>
// NOTICE: KAPTION-INTEGRATION — reusable checkbox-grid column picker for the
// delivery-events export modal. Renders a Select all / none toggle and a grid of
// column checkboxes. Selection is the list of selected column keys (v-model).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  // Array of { key, label }
  columns: { type: Array, default: () => [] },
  // Selected column keys
  modelValue: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const allKeys = computed(() => props.columns.map(c => c.key));
const allSelected = computed(
  () =>
    props.columns.length > 0 &&
    allKeys.value.every(k => props.modelValue.includes(k))
);

const isChecked = key => props.modelValue.includes(key);

const toggle = key => {
  const next = isChecked(key)
    ? props.modelValue.filter(k => k !== key)
    : [...props.modelValue, key];
  emit('update:modelValue', next);
};

const toggleAll = () => {
  emit('update:modelValue', allSelected.value ? [] : [...allKeys.value]);
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <button
      type="button"
      class="self-start text-xs font-medium text-n-blue-text hover:underline"
      @click="toggleAll"
    >
      {{
        allSelected
          ? t('CAMPAIGN.REPORT.EXPORT.SELECT_NONE')
          : t('CAMPAIGN.REPORT.EXPORT.SELECT_ALL')
      }}
    </button>
    <div class="grid grid-cols-2 gap-x-4 gap-y-1.5">
      <label
        v-for="col in columns"
        :key="col.key"
        class="flex items-center gap-2 text-sm text-n-slate-12 cursor-pointer select-none"
      >
        <input
          type="checkbox"
          class="accent-n-brand w-3.5 h-3.5"
          :checked="isChecked(col.key)"
          @change="toggle(col.key)"
        />
        <span class="truncate">{{ col.label }}</span>
      </label>
    </div>
  </div>
</template>
